/* eslint-disable react/no-array-index-key -- TODO: fix this */
import { useRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styles from './ErrorNotifications.module.scss';

import { useAppSelector, useAppDispatch } from '@/store/new-order';
import { NotificationTypes, removeNotification } from '@/store/new-order/notificationsSlice';
import { getNotificationCallback } from '@/utils/notificationCallbacks';

const transitionClassnames = {
  enter: styles.notificationEnter,
  enterActive: styles.notificationEnterActive,
  exit: styles.notificationExit,
  exitActive: styles.notificationExitActive,
};

const Notification = ({ id, text }: { id: string; text: string }) => {
  // `[\u0400-\u04FF]` matches Cyrrilic characters, for the sake of support of Ukrainian
  const segments = text.split(/(\[(?:\w|[\u0400-\u04FF]|\s)+\]\((?:\w|\s|[:/.&?#])+\))/g);

  return (
    <span>
      {segments.map((s, index) => {
        if (s.startsWith('[')) {
          // means it's the link [label](address)
          const linkLabel = /\[([^)]+)\]/.exec(s)?.[1];
          const linkAddress = /\(([^)]+)\)/.exec(s)?.[1];

          const callback = linkAddress ? getNotificationCallback(linkAddress) : null;

          if (callback) {
            return (
              <button key={`${id}-${index}`} type="button" onClick={callback}>
                {linkLabel}
              </button>
            );
          }

          return (
            <a key={`${id}-${index}`} href={linkAddress}>
              {linkLabel}
            </a>
          );
        }

        return s;
      })}
    </span>
  );
};

const NotificationsContainer = () => {
  const ref = useRef<HTMLDivElement>(null);
  const notificationsQueue = useAppSelector((state) => state.notifications.notifications);
  const dispatch = useAppDispatch();

  const onNotificationRemove = (id: string) => () => dispatch(removeNotification(id));

  return (
    <TransitionGroup className={styles.wrapper}>
      {notificationsQueue.map((notificaion) => (
        <CSSTransition in nodeRef={ref} key={notificaion.id} classNames={transitionClassnames} timeout={300}>
          <div
            className={`${styles.notification} ${notificaion.type === NotificationTypes.SUCCESS ? styles.success : ''}`}
            ref={ref}
          >
            <Notification text={notificaion.text} id={notificaion.id} />
            <button className={styles.closeButton} type="button" onClick={onNotificationRemove(notificaion.id)}>
              <img src="/images/notification-close.svg" alt="" />
            </button>
          </div>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};

export default NotificationsContainer;
